var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar9 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-9_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1788FB",
  d: "M60 30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4A72C",
  d: "m20.907 40.418-1.165-1.166-1.165-1.165s-2.302-.3-4.102 2.235-1.47 5.668-1.47 5.668 3.132.33 5.667-1.47c2.535-1.803 2.235-4.103 2.235-4.103"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D13346",
  d: "m24.01 39.945-4.958-4.958-1.98 1.596 5.343 5.342z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EEE",
  d: "M46.995 12.003s-9.792-.585-18.707 7.35S17.12 35.125 17.12 35.125s2.048 1.51 3.645 3.108L46.998 12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26517F",
  d: "M8.045 33.895s3.747-8.245 13.465-7.04c9.717 1.203-4.073 7.355-4.073 7.355s-3.055-2.248-9.392-.312z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6D6D6",
  d: "M46.995 12.003s.585 9.792-7.35 18.707-15.772 11.167-15.772 11.167-1.51-2.047-3.108-3.645L46.998 12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E3A54",
  d: "M25.103 50.953s8.245-3.748 7.04-13.466c-1.203-9.717-7.355 4.073-7.355 4.073s2.247 3.055.312 9.392z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26517F",
  d: "M29.237 29.76s-4.02 1.685-7.54 5.205-5.205 7.54-5.205 7.54z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E3A54",
  d: "M29.237 29.76s-1.685 4.02-5.205 7.54-7.54 5.205-7.54 5.205z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F4A72C",
  d: "M34.617 27.633a3.252 3.252 0 1 0 0-6.505 3.252 3.252 0 0 0 0 6.505"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D13346",
  d: "m39.827 19.17 7.168-7.168s-5.383-.317-11.8 2.75a133 133 0 0 1 4.632 4.418"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A51C34",
  d: "m39.828 19.17 7.167-7.168s.318 5.383-2.75 11.8a133 133 0 0 0-4.417-4.632"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-9_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})))));
export { SvgAvatar9 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-9.86249968bc7c5ccdcb4f.svg";